import { Injectable } from '@angular/core';
import { SectionIdentifier, SectionReview, SectionStatus } from './review-section.domain';
import { Observable } from 'rxjs';
import { ReviewSectionStore } from './review-section.store';
import { map } from 'rxjs/operators';
import { OrderProcesStore } from '../../stores/order-process.store';

@Injectable({
  providedIn: 'root',
})
export class ReviewSectionSelectors {
  constructor(private store: ReviewSectionStore, private orderProcessStore: OrderProcesStore) {}

  public getSectionReview(applicationId: number, sectionIdentifier: SectionIdentifier, entityId: number | null): Observable<SectionReview> {
    return this.store.reviews.pipe(
      map(reviews =>
        reviews.find(
          review => review.section == sectionIdentifier && review.application_id == applicationId && review.entity_id == entityId
        )
      )
    );
  }

  public isSectionApproved(applicationId: number, sectionIdentifier: SectionIdentifier, entityId: number | null): Observable<boolean> {
    return this.getSectionReview(applicationId, sectionIdentifier, entityId).pipe(
      map((sectionReview: SectionReview) => {
        return sectionReview?.status === SectionStatus.approved;
      })
    );
  }

  public areAllSectionsApproved(applicationId: number): Observable<boolean> {
    return this.store.reviews.pipe(
      map(sectionReviews =>
        sectionReviews
          .filter(r => r.application_id === applicationId)
          .every(sectionReview => sectionReview.status === SectionStatus.approved)
      )
    );
  }

  public areAnySectionsRejected(applicationId: number): Observable<boolean> {
    return this.store.reviews.pipe(
      map(sectionReviews =>
        sectionReviews
          .filter(r => r.application_id === applicationId)
          .some(sectionReview => sectionReview.status === SectionStatus.rejected)
      )
    );
  }

  public areAnySectionsWithoutReview(applicationId: number): Observable<boolean> {
    return this.store.reviews.pipe(
      map(sectionReviews =>
        sectionReviews.filter(r => r.application_id === applicationId).some(sectionReview => sectionReview.status === SectionStatus.none)
      )
    );
  }
}
